import { navItems } from "@/mocks/homeContent";

function Footer() {
  return (
    <footer className="bg-secondary-50/70 pt-12">
      <div className="mx-auto w-full max-w-[1280px] px-4 pb-8 md:px-6">
        <div className="flex flex-col justify-between gap-8 border-b border-background-200 pb-8 md:flex-row">
          <div className="max-w-md">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
                吃瓜地址
              </span>
            </div>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              专注记录吃瓜地址的域名迁移与换新地址过程，汇总历史版本、旧网址与发布历史，
              为每一次往期入口回溯提供稳定入口。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            <div>
              <p className="text-sm font-bold text-foreground-900">快速定位</p>
              <ul className="mt-3 space-y-2">
                {navItems.slice(0, 4).map((n) => (
                  <li key={n.href}>
                    <a
                      href={n.href}
                      className="text-sm text-foreground-600 transition-colors hover:text-foreground-950"
                    >
                      {n.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-sm font-bold text-foreground-900">入口档案</p>
              <ul className="mt-3 space-y-2 text-sm text-foreground-600">
                <li>当前在线入口</li>
                <li>备用通道 A</li>
                <li>历史版本镜像</li>
              </ul>
            </div>
            <div>
              <p className="text-sm font-bold text-foreground-900">更新</p>
              <ul className="mt-3 space-y-2 text-sm text-foreground-600">
                <li className="inline-flex items-center gap-1.5">
                  <span className="h-1.5 w-1.5 rounded-full bg-accent-600"></span>
                  最近同步 2026-08-30
                </li>
                <li>收录版本 V9.0</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-3 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 吃瓜地址 · 历史版本与换新地址追踪。仅提供导航与信息整合，不涉及具体内容。</p>
          <p className="inline-flex items-center gap-1 whitespace-nowrap">
            <i className="ri-link-m text-primary-600"></i>
            换新地址 · 旧网址 · 域名迁移
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;